import React, {
	ChangeEvent,
	Ref,
	useRef,
	useImperativeHandle,
	useState,
	KeyboardEvent,
	forwardRef,
	useEffect
} from "react";
import {  CodeResponse, useGoogleLogin } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { Modal } from "react-bootstrap";

import * as authActions from "../../redux/auth/handlers";
import MessageConst from "../../const/Message.const";
import ValidationService from "../../service/Validation.service";
import logo from "../../static/images/winston-logo-small.png";
import google from "../../static/images/google.png";
import "./styles.scss";
import Signup from "./signup"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import * as appActions from "../../redux/app/handlers";
import { StateType } from "../../redux/types";
import close from "../../static/images/close.png"
import axios from "axios";


interface LoginProps {
	isLoginButtonShown: boolean;
	handleLoginModeClick: () => void;
	onRegisterModeClick: () => void;
	handleForgotModeClick: () => void;
	onAddedCallback?: () => void;
}

export interface LoginRefObject {
	doLogin: () => Promise<void>;
}

const Login = forwardRef((props: LoginProps, ref: Ref<LoginRefObject>) => {
	// const { isLoading } = useSelector(({ auth }: StateType) => ({
	// 	isLoading: auth.authLoading
	// }));
	console.log(props, ref ,"login page")
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const emailInput = useRef<HTMLInputElement>(null);
	const passwordInput = useRef<HTMLInputElement>(null);
	const userId = useSelector((state:StateType) => state.auth.profile?.id)
	const showOTPScreen = useSelector((state: StateType) => state.auth.otpShow)
	const [email, setEmail] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const { executeRecaptcha } = useGoogleReCaptcha();
		const [OTPshow, setotpShow] = useState<boolean>();
	
		const otpClose = () => {
			setotpShow(false)
			dispatch(authActions.changeOTPScreenView(false))
			dispatch(authActions.setOTPValidationMessage(""))
		};
		const otpShow = () => setotpShow(true);
	
	const [validationMessage, setValidationMessage] = useState<string>("");
	const [OTPvalidationMessage, setOTPValidationMessage] = useState<string>("");
	
	const [captchaToken, setToken] = useState<string>('');
	// const [newvalidationMessage, setnewValidationMessage] = useState<string>("");
	const [isAgreed] = useState<boolean>(false);
	const isLogin = useRef<boolean>(false);
	const authValidationMessage = useSelector((state: StateType) => state.auth.signInValidationMessage);
	const otpValidationMessage = useSelector((state: StateType) => state.auth.otpValidationMessage)

	useEffect(()=>{
		setValidationMessage(authValidationMessage);
	}, [authValidationMessage]);

	useEffect(()=>{
			setOTPValidationMessage(otpValidationMessage)
	},[otpValidationMessage])

		useEffect(() => {
			if (!executeRecaptcha) {
				return;
			}
			const handleReCaptchaVerify = async () => {
				const token = await executeRecaptcha('login');
				setToken(token);
				console.log(token)
			};
			handleReCaptchaVerify();
		}, [executeRecaptcha]);


	useImperativeHandle(ref, () => ({
		doLogin,
		doRegister
	}));

	useEffect(() => {
		if(props.isLoginButtonShown){
			dispatch(appActions.setIsCheckout(false));
		}		
	},[])

	const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter") {
			doLogin();
			// doRegister();
		}
	};

	// const handleNewEmail = (e: ChangeEvent<HTMLInputElement>) => {
	// 	const newEmail: string = e.target.value.trim();

	// 	setEmail(newEmail);

	// 	if (ValidationService.validateEmail(newEmail)) {
	// 		setValidationMessage("");
	// 	}
	// };
	// const handleNewPassword = (e: ChangeEvent<HTMLInputElement>) => {
	// 	setPassword(e.target.value);

	// 	if (ValidationService.validatePassword(e.target.value)) {
	// 		setValidationMessage("");
	// 	}
	// };
	const handleEmailChange = (event: ChangeEvent<HTMLInputElement>): void => {
		const email = event.target.value.trim();
		setEmail(email);

	};

	const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>): void => {
		setPassword(event.target.value);
	};
	const doRegister = async (): Promise<void> => {
		if (!ValidationService.validateEmail(email)) {
			if (emailInput.current) {
				emailInput.current.focus();
			}

			setValidationMessage(MessageConst.validation.emailError);

			return;
		}

		if (!ValidationService.validatePassword(password)) {
			if (passwordInput.current) {
				passwordInput.current.focus();
			}

			setValidationMessage(MessageConst.validation.passwordError);

			return;
		}
		if (!isAgreed) {
			setValidationMessage(MessageConst.validation.termsOfUseError);

			return;
		}
		let utmSource = window.sessionStorage.getItem("utm_source");
		dispatch(
			authActions.registerRequest({
				email,
				password,
				isAgreed,
				utmSource,
				isLoginMode: pathname === "/login"
			})
		)
	}
	const doLogin = async (): Promise<void> => {
		sessionStorage.setItem("emtyPopup", "open");				

		if (!ValidationService.validateEmail(email)) {
			if (emailInput.current) {
				emailInput.current.focus();
			}

			setValidationMessage(MessageConst.validation.emailError);
			return;
		}

		if (!ValidationService.validatePassword(password)) {
			if (passwordInput.current) {
				passwordInput.current.focus();
			}

			setValidationMessage(MessageConst.validation.passwordError);
			return;
		}

		dispatch(
			authActions.loginRequest({
				email,
				password,
				callback:false,
				"reCaptchaToken":captchaToken,
				isLoginMode: pathname === "/login"
			})
		);
	};

	const [isActive, setActive] = useState(false);

	const toggleClass = () => {
		setActive(!isActive);
	};
	// const handleIsAgreed = (event: ChangeEvent<HTMLInputElement>) => {
	// 	const newAgreedState: boolean = event.target.checked;

	// 	if (!newAgreedState) {
	// 		setValidationMessage(MessageConst.validation.termsOfUseError);
	// 	} else {
	// 		setValidationMessage("");
	// 	}

	// 	setIsAgreed(newAgreedState);
	// };
	const onSuccessSignup = async (res: CodeResponse) => {
		let tokenId = res.code;
		
		let utmSource = window.sessionStorage.getItem("utm_source");
		if (isLogin.current == true) {
			sessionStorage.setItem("emtyPopup", "open");
			dispatch(
				authActions.loginRequest({
					email,
					password,
					isLoginMode: pathname === "/login",
					tokenId
				})
			);
		} else {
			sessionStorage.setItem("emtyPopup", "open");
			dispatch(
				authActions.registerRequest({
					email,
					password,
					isAgreed,
					utmSource,
					isLoginMode: pathname === "/login",
					tokenId
				})
			)
		}
		// res.disconnect();
	}


	const onFailureSignup = (res: any) => {
		console.log('[Login Failed] res:', res);
		
	}


	const signIn  = useGoogleLogin({
		onSuccess: onSuccessSignup,
		onError: onFailureSignup,
		flow: 'auth-code'
	});

	const handleGoogleSignUp = () => {
		isLogin.current = false;
		signIn();
	}

	const handleGoogleSignIn = () => {
		isLogin.current = true;
		signIn();
	}

		const [otp, setOtp] = useState<string[]>(['', '', '', '', '', '']); // State to manage OTP values
	
		const handleInputChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
			const { value } = e.target;
			
			
			if (value.length <= 1 && /^[0-9]*$/.test(value)) {
			  const newOtp = [...otp]; // Copy the current OTP state
			  newOtp[index] = value; // Update the digit at the specific index
		
			  // If the value is not empty, automatically move to the next input
			  if (value && index < otp.length - 1) {
				const nextInput = document.querySelectorAll<HTMLInputElement>('.otpInput')[index + 1];
				nextInput?.focus();
			  }
		
			  setOtp(newOtp); // Update the OTP state
			}
		  };
		  const handleBackspace = (e: KeyboardEvent<HTMLInputElement>, index: number) => {
			if (e.key === 'Backspace' && otp[index] === '') {
			  // If the current OTP field is empty and Backspace is pressed, focus on the previous field
			  if (index > 0) {
				const prevInput = document.querySelectorAll<HTMLInputElement>('.otpInput')[index - 1];
				prevInput?.focus();
			  }
			} else if (e.key === 'Backspace') {
			  // If the current field is not empty, remove the value and update state
			  const newOtp = [...otp];
			  newOtp[index] = ''; // Clear the current OTP value
			  setOtp(newOtp); // Update the OTP state
			}
		  };
		
	  
		const handleOtpFocus = (index: number) => {
		  const otpInputs = document.querySelectorAll<HTMLInputElement>('.otpInput');
		  otpInputs[index]?.focus();
		};

		const doVerifyOTP = async (): Promise<void> => {
	
			if(!ValidationService.validateOTP){

				setOTPValidationMessage(MessageConst.validation.otpRequired);
				return;
			}
			dispatch(authActions.clearSignInValidationMessage());
			dispatch(authActions.verifyUserRequest({
				userId,
				code:otp.join("")
			}))
		
	}

	return (
		<>
		<div className="login-component">

			<div id="login">

				<div className="navbar-3 w-nav" >
					<div className="container-17 w-container">
						<nav role="navigation" className={isActive ? 'nav-menu-2 w-nav-menu show' : 'nav-menu-2 w-nav-menu'}>
							<div className="res-menu">

								<div data-hover="1" data-delay="0" className="w-dropdown">
									<div className="shop-3 w-dropdown-toggle">
										<Link to="/contact-us" className="help-link">
											<div className="text-block-68">Help</div>
										</Link>
									</div>
									<nav className="w-dropdown-list">
										<Link to="/contact-us" className="link-block-9 w-inline-block help-link">
											<div className="text-block-68">Help</div>
										</Link>
									</nav>
								</div>
							</div>
						</nav>
						<div onClick={toggleClass} className={isActive ? 'menu-button w-nav-button bg' : 'menu-button w-nav-button'}>
							<div className="icon w-icon-nav-menu"></div>
						</div>
						<Link to="/" className="link-block-7 w-inline-block">
							<img src={logo} width="151" alt="logo" className="image-22" />
						</Link>
					</div>
				</div>



				<div className="section">

					<Tabs className="container w-container">
						<div className="w-row">
							<div className="w-col w-col-3"></div>
							<div className="column-69 w-col w-col-6">
								<TabList className="columns-38 w-row authTabList">
									<Tab className="w-col w-col-6" onClick={props.onRegisterModeClick}>
										<span className="button-2 w-button">Sign Up</span>
									</Tab>
									<Tab className="w-col w-col-6" onClick={props.handleLoginModeClick}>
										<span className="button-3 w-button">Log In</span>
									</Tab>
								</TabList>
							</div>
						</div>

						<div className="container-13 w-container">
							<div className="w-row">
								<div className="w-col w-col-3"></div>
								<div className="column-49 w-col w-col-6">
									<TabPanel>
										<Signup
											doRegister={doRegister}
										/>
									</TabPanel>
									<TabPanel>
										<div className="div-block-40">
											<h1 className="heading-2">Welcome back</h1>
											<p className="paragraph-2">Log in to your Winston platform account to continue your online visit.</p>
											<div className="w-form">
												<form id="email-form" name="email-form" data-name="Email Form" className="form">
													<input type="email" className="text-field-3 w-input" placeholder="Email address" id="name-2" required ref={emailInput}
														value={email}
														onChange={handleEmailChange}
														onKeyDown={handleKeyPress}
													/>
													<input type="password" className="text-field-4 w-input" placeholder="Password" id="email-2" required
														ref={passwordInput}
														value={password}
														onChange={handlePasswordChange}
														onKeyDown={handleKeyPress}
													/>

													<Link to="/forgot-password" className="link-3">Forgot Password ?</Link>

													<div className={validationMessage ? "w-form-fail-show" : "w-form-fail"}>
														<div dangerouslySetInnerHTML={{ __html: validationMessage }}></div>
													</div>

													<span onClick={doLogin} className="button-9 w-button"><strong>Sign in</strong></span>
													<div className="div-block-41"><img src={google} alt="google" className="image-19 googleImg" />
														<button type="button" onClick={handleGoogleSignIn} className="heading-30">Log In with Google</button>
													</div>
												</form>

												{/* validation column */}


												{/* <div className="w-form-done">
										<div>Thank you! Your submission has been received!</div>
									</div>
									<div className="w-form-fail">
										<div>Oops! Something went wrong while submitting the form.</div>
									</div> */}
											</div>
										</div>
									</TabPanel>
								</div>
								<div className="w-col w-col-3"></div>
							</div>
						</div>
					</Tabs>



				</div>

			</div>

		</div>
		<Modal show={OTPshow} animation={false} className="otpModal" backdrop="static">
				 <div className="modal-content">
      			<div className="modal-header">
       			<h5 className="modal-title">OTP Verification</h5>
        		<button
					type="button"
					className="close"
					aria-label="Close"
					onClick={otpClose}
				>
          		<img src={close} width="25" alt="close" />
        	  </button>
      		</div>
      <div className="modal-body">
        <h3 className="optBodyHeading">Enter your verification code</h3>
        <p className="optBodyDescription">We will send you an One Time Password</p>
        <div className="otpFields">
          {otp.map((digit, index) => (
            <input
              key={index}
              className="otpInput"
              type="number"
              value={digit}
              maxLength={1} // Only one digit per input
			  onChange={(e) => handleInputChange(e, index)}
			  onKeyDown={(e) => handleBackspace(e, index)}
              onFocus={() => handleOtpFocus(index)}
            />
          ))}
        </div>
		  {/*validation message*/}
		<div className={OTPvalidationMessage ? "w-form-fail-show" : "w-form-fail"}>
			<div dangerouslySetInnerHTML={{ __html: OTPvalidationMessage }}></div>
		</div>
        {/* <div className="otpResend">
          <div>
            <p>Didn't get it?</p>
            <button className="resendBtn" type="button">Resend code</button>
          </div>
          <p className="otpTime">1:00</p>
        </div> */}
        <div className="otpVerifyBtn-block">
		<button className="otpVerifyBtn" type="button" onClick={doVerifyOTP}>Verify OTP</button>
	</div>
      </div>

      {/* Invisible input field to type OTP */}
      <input
        type="text"
        value={otp.join('')}
		onChange={(e) => handleInputChange(e, 0)} 
        className="invisibleInput" // Invisible to the user
        autoFocus
      />
    </div>
	
			</Modal>
		</>
	);
});
export default Login;
